import { anatomy } from "@chakra-ui/theme-tools";

export const surfaceAnatomy: any = anatomy("surface").parts("root", "header", "section");
